import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children, redirectTo = '/' }) => {
  const { jtoken, token } = useAuth();

  return (token && jtoken) ?<Navigate to={redirectTo} /> : children;

};

export default PublicRoute;
